import { useFlags } from 'launchdarkly-react-client-sdk';

import { usePartner } from 'components/app/routes/usePartner';
import { PARTNERS } from 'config/app-config';

export const useAllowJourney = () => {
  const { activePartner } = usePartner();
  const {
    allowJourneyDefault,
    allowJourneyVoicesalesHomemove,
    allowJourneyVoicesalesWinback,
    allowJourneyVoicesalesAcquisition,
    allowJourneyNondomesticTransfer,
    allowJourneyMoveIn
  } = useFlags();

  switch (true) {
    case activePartner[PARTNERS.VOICESALES_HOMEMOVE]:
      return allowJourneyVoicesalesHomemove;
    case activePartner[PARTNERS.VOICESALES_WINBACK]:
      return allowJourneyVoicesalesWinback;
    case activePartner[PARTNERS.VOICESALES_ACQUISITION]:
      return allowJourneyVoicesalesAcquisition;
    case activePartner[PARTNERS.NONDOMESTIC_TRANSFER]:
      return allowJourneyNondomesticTransfer;
    case activePartner[PARTNERS.MOVE_IN]:
      return allowJourneyMoveIn;
    default:
      return allowJourneyDefault;
  }
};
